import Button from '@/components/Buttons/Button';

const DefaultFooterButtons = () => (
  <>
    <Button
      disabled
      sx={{
        '&.Mui-disabled': {
          opacity: 1,
          border: '1px solid'
        }
      }}
      variant='outlined'
    >
      Cancel
    </Button>
    <Button
      disabled
      sx={{
        '&.Mui-disabled': {
          opacity: 1,
          backgroundColor: 'gx.neutral'
        }
      }}
      variant='contained'
    >
      Download
    </Button>
  </>
);

export default DefaultFooterButtons;
